import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MduService {
  constructor() {}

  public isMdu(luCount: number, buCount: number, suCount: number) {
    return luCount + buCount + suCount > 1;
  }
}
